import React, { useState } from 'react';
import {
  Droplet,
  Home as HomeIcon,
  Sparkles,
  Palette,
  CheckCircle,
  MapPin,
  Phone,
  Mail,
  ChevronLeft,
  ChevronRight,
  Menu,
  X,
  MessageCircle,
  Copy } from
'lucide-react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../components/ui/dialog';

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showCallDialog, setShowCallDialog] = useState(false);
  const [copied, setCopied] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const phoneNumber = '01202985018';
  const formattedPhone = '01202 985018';
  const displayPhone = '01202 985018';

  const handleCallClick = () => {
    // Check if mobile device
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    
    if (isMobile) {
      // Direct call on mobile
      window.location.href = `tel:${phoneNumber}`;
    } else {
      // Show dialog on desktop
      setShowCallDialog(true);
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(displayPhone);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const galleryImages = [
  {
    before: 'https://customer-assets.emergentagent.com/job_highcliffe-clean/artifacts/ckpfp8lc_IMG_7709.JPEG',
    during: 'https://customer-assets.emergentagent.com/job_highcliffe-clean/artifacts/mh7zjqtz_IMG_7746.JPEG',
    after: 'https://customer-assets.emergentagent.com/job_highcliffe-clean/artifacts/nzhmi66k_IMG_7782.JPEG',
    title: 'Driveway Restoration Project'
  },
  {
    before: 'https://customer-assets.emergentagent.com/job_highcliffe-clean/artifacts/jze6wzko_B4.jpg',
    after: 'https://customer-assets.emergentagent.com/job_highcliffe-clean/artifacts/tm0atypg_AFTER.jpg',
    title: 'Patio Deep Clean Transformation'
  },
  {
    before: 'https://customer-assets.emergentagent.com/job_highcliffe-clean/artifacts/pnlamso4_smartseal-block-magic-grey-25l-a-re-colouring-block-paving-sealer-superior-to-concrete-paint-transform-old-driveways~5061002784560_02c_MP.jfif',
    after: 'https://customer-assets.emergentagent.com/job_highcliffe-clean/artifacts/n9db0rjk_smartseal-block-magic-grey-25l-a-re-colouring-block-paving-sealer-superior-to-concrete-paint-transform-old-driveways~5061002784560_03c_MP.webp',
    title: 'Grey Block Paving Transformation'
  },
  {
    before: 'https://customer-assets.emergentagent.com/job_highcliffe-clean/artifacts/mhbb58jc_smartseal-block-magic-black-25l-a-re-colouring-block-paving-sealer-superior-to-concrete-paint-transform-old-driveways~5061002784645_04c_MP.jfif',
    after: 'https://customer-assets.emergentagent.com/job_highcliffe-clean/artifacts/b36cuqwb_smartseal-block-magic-black-25l-a-re-colouring-block-paving-sealer-superior-to-concrete-paint-transform-old-driveways~5061002784645_05c_MP.jfif',
    title: 'Black Block Paving Restoration'
  }];


  const services = [
  {
    icon: <HomeIcon className="w-8 h-8" />,
    title: 'Driveway Cleaning',
    description: 'Professional deep cleaning to remove dirt, moss, and algae, restoring your driveway to its original beauty.'
  },
  {
    icon: <Droplet className="w-8 h-8" />,
    title: 'Patio Cleaning',
    description: 'Transform your outdoor living space with our expert patio cleaning services, perfect for entertaining.'
  },
  {
    icon: <Sparkles className="w-8 h-8" />,
    title: 'General Pressure Washing',
    description: 'Complete exterior surface cleaning for walls, pathways, decking, and more.'
  },
  {
    icon: <Palette className="w-8 h-8" />,
    title: 'Block Paving Re-Colouring',
    description: 'Using premium Block Magic from Smartseal to restore colour and enhance the appearance of block paving.'
  }];


  const benefits = [
  'Local to Highcliffe & BCP Area',
  'Father & Son Family-Run Business',
  'Friendly, Reliable Service',
  'Attention to Detail',
  'Competitive Pricing',
  'Free Quotes'];


  const serviceAreas = [
  'Bournemouth',
  'Christchurch',
  'Poole',
  'New Forest',
  'Highcliffe',
  'Southbourne',
  'Mudeford',
  'Barton on Sea',
  'New Milton',
  'Ringwood',
  'Milford on Sea',
  'Lymington',
  'Brockenhurst',
  'Friars Cliff',
  'Bransgore',
  'Hordle'
];


  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % galleryImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          access_key: process.env.REACT_APP_WEB3FORMS_KEY,
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          message: formData.message,
          subject: 'New Quote Request from BCP Website',
          from_name: 'BCP Website Contact Form',
          to_email: 'info@bcpexteriorcleaning.co.uk'
        }),
      });

      const data = await response.json();

      if (data.success) {
        alert('Thank you! Your message has been sent. We will contact you shortly.');
        setFormData({ name: '', email: '', phone: '', message: '' });
      } else {
        alert('Oops! Something went wrong. Please email us directly at info@bcpexteriorclean.co.uk');
      }
    } catch (error) {
      alert('Oops! Something went wrong. Please email us directly at info@bcpexteriorclean.co.uk');
    }
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header/Navigation */}
      <header className="fixed top-0 w-full bg-white/95 backdrop-blur-sm shadow-sm z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center space-x-2">
              <Droplet className="w-8 h-8 text-[#8C52FF]" />
              <span className="text-2xl font-bold bg-gradient-to-r from-[#8C52FF] to-[#5E17EB] bg-clip-text text-transparent">
                BCP Exterior Cleaning
              </span>
            </div>
            
            {/* Desktop Navigation */}
            <nav className="hidden md:flex space-x-8">
              <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-[#8C52FF] transition-colors font-medium">
                About
              </button>
              <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-[#8C52FF] transition-colors font-medium">
                Services
              </button>
              <button onClick={() => scrollToSection('gallery')} className="text-gray-700 hover:text-[#8C52FF] transition-colors font-medium">
                Gallery
              </button>
              <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-[#8C52FF] transition-colors font-medium">
                Contact
              </button>
            </nav>

            <div className="hidden md:block">
              <Button
                onClick={() => scrollToSection('contact')}
                className="bg-gradient-to-r from-[#8C52FF] to-[#5E17EB] hover:opacity-90 text-white font-semibold px-6">

                Get Free Quote
              </Button>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>

              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>

          {/* Mobile Navigation */}
          {mobileMenuOpen &&
          <nav className="md:hidden pb-4 space-y-2">
              <button onClick={() => scrollToSection('about')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 rounded">
                About
              </button>
              <button onClick={() => scrollToSection('services')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 rounded">
                Services
              </button>
              <button onClick={() => scrollToSection('gallery')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 rounded">
                Gallery
              </button>
              <button onClick={() => scrollToSection('contact')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 rounded">
                Contact
              </button>
              <Button
              onClick={() => scrollToSection('contact')}
              className="w-full bg-gradient-to-r from-[#8C52FF] to-[#5E17EB] hover:opacity-90 text-white">

                Get Free Quote
              </Button>
            </nav>
          }
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative pt-24 pb-20 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-purple-50 to-white opacity-70"></div>
          <div className="absolute top-20 right-0 w-96 h-96 bg-[#8C52FF] rounded-full blur-3xl opacity-10"></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-400 rounded-full blur-3xl opacity-10"></div>
        </div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <h1 className="text-5xl md:text-6xl font-bold leading-tight">
                <span className="bg-gradient-to-r from-[#8C52FF] to-[#5E17EB] bg-clip-text text-transparent">
                  Professional
                </span>
                <br />
                <span className="text-gray-900">Pressure Washing</span>
                <br />
                <span className="text-gray-700 text-3xl md:text-4xl">in Bournemouth Christchurch and Poole</span>
              </h1>
              <p className="text-xl text-gray-600 leading-relaxed">
                Driveways, patios, and exterior surfaces cleaned and restored to look like new
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Button
                  onClick={() => scrollToSection('contact')}
                  size="lg"
                  className="bg-gradient-to-r from-[#8C52FF] to-[#5E17EB] hover:opacity-90 text-white font-semibold px-8 py-6 text-lg">

                  Get Your Free Quote
                </Button>
                <Button
                  onClick={handleCallClick}
                  size="lg"
                  variant="outline"
                  className="border-2 border-[#8C52FF] text-[#8C52FF] hover:bg-[#8C52FF] hover:text-white font-semibold px-8 py-6 text-lg">

                  <Phone className="w-5 h-5 mr-2" />
                  Call Now
                </Button>
              </div>
            </div>
            <div className="relative">
              <div className="rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="https://customer-assets.emergentagent.com/job_highcliffe-clean/artifacts/94u1chdd_patio-cleaning-jesmond-pressure-washing.jpg"
                  alt="Professional block paving pressure washing - dramatic before and after cleaning"
                  className="w-full h-[500px] object-cover" />

              </div>
              <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-xl p-6 max-w-xs">
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-r from-[#8C52FF] to-[#5E17EB] flex items-center justify-center">
                    <CheckCircle className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <p className="font-bold text-gray-900">Family-Run Business</p>
                    <p className="text-sm text-gray-600">Trusted Local Service</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">About BCP Exterior Cleaning</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-[#8C52FF] to-[#5E17EB] mx-auto rounded-full"></div>
          </div>
          
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <img
                src="https://customer-assets.emergentagent.com/job_highcliffe-clean/artifacts/ibneefbl_driveway-cleaning-gosforth-pressure-washing.jpg"
                alt="Driveway pressure washing in action"
                className="rounded-2xl shadow-xl w-full h-[400px] object-cover" />

            </div>
            <div className="space-y-6">
              <h3 className="text-3xl font-bold text-gray-900">
                Father & Son, <span className="text-[#8C52FF]">Family-Run Team</span>
              </h3>
              <p className="text-lg text-gray-600 leading-relaxed">BCP Exterior Cleaning is a family-run pressure washing business based in Highcliffe, proudly serving the Bournemouth, Christchurch, Poole and surrounding area.

              </p>
              <p className="text-lg text-gray-600 leading-relaxed">
                As a father-and-son team, we bring a personal, reliable approach to every job. We're committed to quality workmanship and ensuring complete customer satisfaction with every project we undertake.
              </p>
              <div className="grid grid-cols-2 gap-4 pt-4">
                {benefits.slice(0, 4).map((benefit, index) =>
                <div key={index} className="flex items-start space-x-2">
                    <CheckCircle className="w-5 h-5 text-[#8C52FF] mt-1 flex-shrink-0" />
                    <span className="text-gray-700">{benefit}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Services</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-[#8C52FF] to-[#5E17EB] mx-auto rounded-full mb-4"></div>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Professional cleaning solutions for all your exterior surfaces
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {services.map((service, index) =>
            <Card
              key={index}
              className="p-6 hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-2 border-transparent hover:border-[#8C52FF] group">

                <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-[#8C52FF] to-[#5E17EB] flex items-center justify-center mb-4 text-white group-hover:scale-110 transition-transform">
                  {service.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-600 leading-relaxed">{service.description}</p>
              </Card>
            )}
          </div>

          <div className="mt-16 bg-gradient-to-r from-[#8C52FF] to-[#5E17EB] rounded-2xl p-8 text-white">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-3xl font-bold mb-4">Block Magic Re-Colouring</h3>
                <p className="text-lg leading-relaxed opacity-95">
                  We use premium Block Magic from Smartseal, a professional-grade product that doesn't just clean – it transforms. This advanced re-colouring sealer restores the original colour of your block paving and provides long-lasting protection.
                </p>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="relative">
                  <img
                    src="https://customer-assets.emergentagent.com/job_highcliffe-clean/artifacts/phu65mjm_smartseal-block-magic-grey-25l-a-re-colouring-block-paving-sealer-superior-to-concrete-paint-transform-old-driveways~5061002784560_04c_MP.jfif"
                    alt="Block paving before Block Magic re-colouring"
                    className="rounded-xl h-40 w-full object-cover" />
                  <div className="absolute top-2 left-2 bg-white/90 px-3 py-1 rounded-lg text-sm font-semibold text-gray-700">
                    Before
                  </div>
                </div>

                <div className="relative">
                  <img
                    src="https://customer-assets.emergentagent.com/job_highcliffe-clean/artifacts/kx3ks0p2_smartseal-block-magic-grey-25l-a-re-colouring-block-paving-sealer-superior-to-concrete-paint-transform-old-driveways~5061002784560_05c_MP.webp"
                    alt="Block paving after Block Magic re-colouring transformation"
                    className="rounded-xl h-40 w-full object-cover" />
                  <div className="absolute top-2 left-2 bg-[#8C52FF] px-3 py-1 rounded-lg text-sm font-semibold text-white">
                    After Block Magic
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Before & After Gallery */}
      <section id="gallery" className="py-20 bg-gradient-to-br from-gray-50 to-purple-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Dramatic Transformations</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-[#8C52FF] to-[#5E17EB] mx-auto rounded-full mb-4"></div>
            <p className="text-xl text-gray-600">See the difference our professional cleaning makes</p>
          </div>

          <div className="relative max-w-5xl mx-auto">
            <div className="bg-white rounded-2xl shadow-2xl p-8">
              <h3 className="text-2xl font-bold text-center mb-8 text-gray-900">
                {galleryImages[currentSlide].title}
              </h3>
              
              <div className="grid md:grid-cols-3 gap-6 mb-6">
                <div className="space-y-2">
                  <p className="text-center font-semibold text-gray-700 text-sm uppercase tracking-wide">Before</p>
                  <img
                    src={galleryImages[currentSlide].before}
                    alt="Before cleaning"
                    className="rounded-xl w-full h-64 object-cover shadow-lg" />

                </div>
                
                {galleryImages[currentSlide].during &&
                <div className="space-y-2">
                    <p className="text-center font-semibold text-[#8C52FF] text-sm uppercase tracking-wide">Cleaned</p>
                    <img
                    src={galleryImages[currentSlide].during}
                    alt="During cleaning"
                    className="rounded-xl w-full h-64 object-cover shadow-lg border-2 border-[#8C52FF]" />

                  </div>
                }
                
                <div className="space-y-2">
                  <p className="text-center font-semibold text-[#5E17EB] text-sm uppercase tracking-wide">
                    {galleryImages[currentSlide].during ? 'Stained' : 'After'}
                  </p>
                  <img
                    src={galleryImages[currentSlide].after}
                    alt="After cleaning"
                    className="rounded-xl w-full h-64 object-cover shadow-lg border-2 border-[#5E17EB]" />

                </div>
              </div>

              {/* Slider Controls */}
              <div className="flex justify-center items-center space-x-4">
                <Button
                  onClick={prevSlide}
                  variant="outline"
                  size="icon"
                  className="rounded-full border-2 border-[#8C52FF] text-[#8C52FF] hover:bg-[#8C52FF] hover:text-white">

                  <ChevronLeft className="w-5 h-5" />
                </Button>
                
                <div className="flex space-x-2">
                  {galleryImages.map((_, index) =>
                  <button
                    key={index}
                    onClick={() => setCurrentSlide(index)}
                    className={`w-3 h-3 rounded-full transition-all ${
                    index === currentSlide ?
                    'bg-gradient-to-r from-[#8C52FF] to-[#5E17EB] w-8' :
                    'bg-gray-300 hover:bg-gray-400'}`
                    } />

                  )}
                </div>

                <Button
                  onClick={nextSlide}
                  variant="outline"
                  size="icon"
                  className="rounded-full border-2 border-[#8C52FF] text-[#8C52FF] hover:bg-[#8C52FF] hover:text-white">

                  <ChevronRight className="w-5 h-5" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Why Choose Us</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-[#8C52FF] to-[#5E17EB] mx-auto rounded-full"></div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {benefits.map((benefit, index) =>
            <div
              key={index}
              className="flex items-center space-x-4 p-6 rounded-xl bg-gradient-to-br from-blue-50 to-purple-50 hover:shadow-lg transition-shadow">

                <CheckCircle className="w-8 h-8 text-[#8C52FF] flex-shrink-0" />
                <span className="text-lg font-semibold text-gray-900">{benefit}</span>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Service Area */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Areas We Serve</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-[#8C52FF] to-[#5E17EB] mx-auto rounded-full mb-4"></div>
            <p className="text-xl text-gray-600">Proudly serving the BCP area</p>
          </div>

          <div className="grid md:grid-cols-4 gap-6 max-w-4xl mx-auto">
            {serviceAreas.map((area, index) =>
            <Card key={index} className="p-6 text-center hover:shadow-xl transition-shadow border-2 border-transparent hover:border-[#8C52FF]">
                <MapPin className="w-10 h-10 text-[#8C52FF] mx-auto mb-3" />
                <h3 className="text-xl font-bold text-gray-900">{area}</h3>
              </Card>
            )}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Get Your Free Quote Today</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-[#8C52FF] to-[#5E17EB] mx-auto rounded-full mb-4"></div>
            <p className="text-xl text-gray-600">Ready to transform your exterior surfaces?</p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto">
            <div className="space-y-8">
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Contact Information</h3>
                <div className="space-y-4">
                  <a
                    href="tel:01202985018"
                    className="flex items-center space-x-4 p-4 rounded-xl bg-gradient-to-br from-blue-50 to-purple-50 hover:shadow-lg transition-shadow group">

                    <div className="w-12 h-12 rounded-full bg-gradient-to-r from-[#8C52FF] to-[#5E17EB] flex items-center justify-center group-hover:scale-110 transition-transform">
                      <Phone className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <p className="text-sm text-gray-600">Call us now</p>
                      <p className="text-xl font-bold text-gray-900">01202 985018</p>
                    </div>
                  </a>

                  <a
                    href="mailto:info@bcpexteriorcleaning.co.uk"
                    className="flex items-center space-x-4 p-4 rounded-xl bg-gradient-to-br from-blue-50 to-purple-50 hover:shadow-lg transition-shadow group cursor-pointer"
                  >
                    <div className="w-12 h-12 rounded-full bg-gradient-to-r from-[#8C52FF] to-[#5E17EB] flex items-center justify-center group-hover:scale-110 transition-transform">
                      <Mail className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <p className="text-sm text-gray-600">Email us</p>
                      <p className="text-xl font-bold text-gray-900">info@bcpexteriorcleaning.co.uk</p>
                    </div>
                  </a>

                  <div className="flex items-center space-x-4 p-4 rounded-xl bg-gradient-to-br from-blue-50 to-purple-50">
                    <div className="w-12 h-12 rounded-full bg-gradient-to-r from-[#8C52FF] to-[#5E17EB] flex items-center justify-center">
                      <MapPin className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <p className="text-sm text-gray-600">Location</p>
                      <p className="text-xl font-bold text-gray-900">Highcliffe, BCP Area</p>
                    </div>
                  </div>
                </div>

                <a
                  href="https://wa.me/447816274397?text=Hi%2C%20I%27d%20like%20to%20get%20a%20quote%20for%20pressure%20washing%20services"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-4 p-4 rounded-xl bg-[#25D366] hover:bg-[#20BA5A] transition-all hover:shadow-lg group cursor-pointer"
                >
                  <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center group-hover:scale-110 transition-transform">
                    <MessageCircle className="w-6 h-6 text-[#25D366]" />
                  </div>
                  <div>
                    <p className="text-sm text-white/90">WhatsApp us</p>
                    <p className="text-xl font-bold text-white">Chat Now</p>
                  </div>
                </a>
              </div>

              <div className="bg-gradient-to-r from-[#8C52FF] to-[#5E17EB] rounded-xl p-6 text-white">
                <h4 className="text-xl font-bold mb-2">Free, No-Obligation Quotes</h4>
                <p className="opacity-95">
                  Get in touch today for a free quote. We'll assess your requirements and provide competitive pricing with no hidden fees.
                </p>
              </div>
            </div>

            <Card className="p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Send us a Message</h3>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Name</label>
                  <Input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    placeholder="Your name"
                    className="w-full" />

                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                  <Input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    placeholder="your.email@example.com"
                    className="w-full" />

                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Phone</label>
                  <Input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="Your phone number"
                    className="w-full" />

                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Message</label>
                  <Textarea
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    required
                    rows={4}
                    placeholder="Tell us about your project..."
                    className="w-full" />

                </div>

                <Button
                  type="submit"
                  className="w-full bg-gradient-to-r from-[#8C52FF] to-[#5E17EB] hover:opacity-90 text-white font-semibold py-6 text-lg">

                  Get Your Free Quote
                </Button>
              </form>
            </Card>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            <div>
              <div className="flex items-center space-x-2 mb-4">
                <Droplet className="w-8 h-8 text-[#8C52FF]" />
                <span className="text-xl font-bold">BCP Exterior Cleaning</span>
              </div>
              <p className="text-gray-400 leading-relaxed">
                Professional pressure washing services in Highcliffe and the BCP area. Family-run business dedicated to quality and customer satisfaction.
              </p>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-4">Quick Links</h4>
              <div className="space-y-2">
                <button onClick={() => scrollToSection('about')} className="block text-gray-400 hover:text-white transition-colors">
                  About Us
                </button>
                <button onClick={() => scrollToSection('services')} className="block text-gray-400 hover:text-white transition-colors">
                  Services
                </button>
                <button onClick={() => scrollToSection('gallery')} className="block text-gray-400 hover:text-white transition-colors">
                  Gallery
                </button>
                <button onClick={() => scrollToSection('contact')} className="block text-gray-400 hover:text-white transition-colors">
                  Contact
                </button>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-4">Service Areas</h4>
              <div className="space-y-2">
                {serviceAreas.map((area, index) =>
                <p key={index} className="text-gray-400">{area}</p>
                )}
              </div>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-8 text-center">
            <p className="text-gray-400">
              © 2024 BCP Exterior Cleaning. All rights reserved.
            </p>
            <p className="text-gray-500 text-sm mt-2">
              Company Registration Number: 17205188
            </p>
          </div>
        </div>
      </footer>

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/447816274397?text=Hi%2C%20I%27d%20like%20to%20get%20a%20quote%20for%20pressure%20washing%20services"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full p-4 shadow-2xl transition-all hover:scale-110 flex items-center space-x-3 group"
      >
        <MessageCircle className="w-7 h-7" />
        <span className="hidden group-hover:inline-block font-semibold pr-2 whitespace-nowrap">
          WhatsApp Us
        </span>
      </a>

      {/* Call Dialog for Desktop */}
      <Dialog open={showCallDialog} onOpenChange={setShowCallDialog}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle className="text-2xl font-bold text-center">Call BCP Exterior Cleaning</DialogTitle>
            <DialogDescription className="text-center">
              Give us a call for a free, no-obligation quote
            </DialogDescription>
          </DialogHeader>
          <div className="flex flex-col items-center space-y-6 py-6">
            <div className="w-20 h-20 rounded-full bg-gradient-to-r from-[#8C52FF] to-[#5E17EB] flex items-center justify-center">
              <Phone className="w-10 h-10 text-white" />
            </div>
            <div className="text-center">
              <p className="text-sm text-gray-600 mb-2">Our Phone Number</p>
              <p className="text-4xl font-bold text-gray-900 tracking-wide">{formattedPhone}</p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 w-full">
              <Button
                onClick={copyToClipboard}
                variant="outline"
                className="flex-1 border-2 border-[#8C52FF] text-[#8C52FF] hover:bg-[#8C52FF] hover:text-white"
              >
                <Copy className="w-4 h-4 mr-2" />
                {copied ? 'Copied!' : 'Copy Number'}
              </Button>
              <Button
                onClick={() => window.location.href = `tel:${phoneNumber}`}
                className="flex-1 bg-gradient-to-r from-[#8C52FF] to-[#5E17EB] hover:opacity-90 text-white"
              >
                <Phone className="w-4 h-4 mr-2" />
                Call Now
              </Button>
            </div>
            <p className="text-sm text-gray-500 text-center">
              Available for quotes and consultations
            </p>
          </div>
        </DialogContent>
      </Dialog>
    </div>);

};

export default Home;